var _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThermometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_715_14757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7732 16.1125L8.8632 3.2025C7.3032 1.6425 4.7732 1.6425 3.2032 3.2025C1.6432 4.7625 1.6432 7.2925 3.2032 8.8625L16.1132 21.7725C15.7232 23.9525 16.3732 26.2725 18.0532 27.9525C20.7832 30.6825 25.2232 30.6825 27.9532 27.9525C30.6832 25.2225 30.6832 20.7825 27.9532 18.0525C26.2732 16.3725 23.9532 15.7325 21.7732 16.1125Z",
    fill: "url(#paint0_linear_715_14757)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 27.9862C25.7888 27.9862 28.0273 25.7477 28.0273 22.9862C28.0273 20.2248 25.7888 17.9862 23.0273 17.9862C20.2659 17.9862 18.0273 20.2248 18.0273 22.9862C18.0273 25.7477 20.2659 27.9862 23.0273 27.9862Z",
    fill: "url(#paint1_radial_715_14757)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 27.9862C25.7888 27.9862 28.0273 25.7477 28.0273 22.9862C28.0273 20.2248 25.7888 17.9862 23.0273 17.9862C20.2659 17.9862 18.0273 20.2248 18.0273 22.9862C18.0273 25.7477 20.2659 27.9862 23.0273 27.9862Z",
    fill: "url(#paint2_radial_715_14757)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6475 4.60627C3.8675 5.38627 3.8675 6.65629 4.6475 7.43629L18.4032 21.1395L21.2332 18.3095L7.4775 4.60627C6.6875 3.82627 5.4275 3.82627 4.6475 4.60627Z",
    fill: "url(#paint3_linear_715_14757)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6475 4.60627C3.8675 5.38627 3.8675 6.65629 4.6475 7.43629L18.4032 21.1395L21.2332 18.3095L7.4775 4.60627C6.6875 3.82627 5.4275 3.82627 4.6475 4.60627Z",
    fill: "url(#paint4_radial_715_14757)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6144 24.9972C25.9612 24.9972 27.053 23.9054 27.053 22.5585C27.053 21.2117 25.9612 20.1199 24.6144 20.1199C23.2676 20.1199 22.1758 21.2117 22.1758 22.5585C22.1758 23.9054 23.2676 24.9972 24.6144 24.9972Z",
    fill: "url(#paint5_linear_715_14757)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_715_14757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.08984 3.14123C6.4388 3.03185 7.38359 3.05998 8.37109 4.04748C9.35859 5.03498 17.3659 13.1048 21.2461 17.0162",
    stroke: "url(#paint6_linear_715_14757)",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.648 15.2263L18.768 13.1062L20.178 14.5162L18.058 16.6362C17.668 17.0262 17.038 17.0262 16.648 16.6362C16.258 16.2462 16.258 15.6163 16.648 15.2263Z",
    fill: "#3D2A5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4077 10.9862L14.5277 8.86624L15.9377 10.2762L13.8177 12.3962C13.4277 12.7862 12.7977 12.7862 12.4077 12.3962C12.0177 12.0062 12.0177 11.3762 12.4077 10.9862Z",
    fill: "#3D2A5B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1675 6.73624L10.2875 4.61624L11.6975 6.02625L9.5775 8.14624C9.1875 8.53624 8.5575 8.53624 8.1675 8.14624C7.7775 7.76624 7.7775 7.12624 8.1675 6.73624Z",
    fill: "#3D2A5B"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_715_14757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0273 28.8326C26.2562 28.8326 28.8737 26.2151 28.8737 22.9862C28.8737 19.7573 26.2562 17.1398 23.0273 17.1398",
    stroke: "url(#paint7_linear_715_14757)",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_715_14757",
    x: 2.0332,
    y: 2.0325,
    width: 27.9668,
    height: 27.9675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.643137 0 0 0 0 0.721569 0 0 0 0 0.929412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14757"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_715_14757",
    x: 4.96484,
    y: 1.97229,
    width: 17.4062,
    height: 16.1689,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_715_14757"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_715_14757",
    x: 21.9023,
    y: 16.0148,
    width: 8.0957,
    height: 13.9428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_715_14757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_14757",
    x1: 16.6739,
    y1: 22.1296,
    x2: 22.6492,
    y2: 15.7457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208333,
    stopColor: "#A8D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_14757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4312 21.2452) rotate(157.855) scale(7.99354 7.99354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.55222,
    stopColor: "#FF285E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC2238"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_715_14757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7113 19.3555) rotate(45.6161) scale(1.67933 2.85078)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40578,
    stopColor: "#F12D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F12D4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_14757",
    x1: 11.0084,
    y1: 13.7926,
    x2: 13.8368,
    y2: 10.9642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C81871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF389D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_715_14757",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7328 20.2748) rotate(-175.285) scale(4.97069 9.43537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3262",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_715_14757",
    x1: 23.7462,
    y1: 20.1199,
    x2: 23.7462,
    y2: 24.9972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733331,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_715_14757",
    x1: 4.37109,
    y1: 1.39124,
    x2: 10.1112,
    y2: 21.0757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8F6FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321794,
    stopColor: "#C8F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_715_14757",
    x1: 24.7216,
    y1: 22.1803,
    x2: 29.2639,
    y2: 22.1793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8F6FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989832,
    stopColor: "#C8F6FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/Thermometer.6ad0434685057739c6ae6d88f4331682.svg";
export { ForwardRef as ReactComponent };